module.exports = __webpack_public_path__ + "static/media/transactions.785247c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/account/assets/images/transactions.png
// module id = 1260
// module chunks = 2